import { Button } from "@repo/ui/components/Base/Button";
import { useLoginRouting } from "@/hooks";
import { Loader2Icon, RefreshCcwIcon, SendHorizonalIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { sendEmailVerification } from "firebase/auth";
import { config } from "@/config";
import { FirebaseError } from "firebase/app";
import { auth } from "@/services/auth";
import { toast } from "react-toastify";

const resendWaitTime = 60;

export const VerifyPage = () => {
  useLoginRouting();
  const refreshPage = () => {
    window.location.reload();
  };

  const [counter, setCounter] = useState(resendWaitTime);
  const [loading, setLoading] = useState(false);
  const [resent, setResent] = useState(false);

  const handleResend = async () => {
    if (counter) return;

    setResent(false);
    setLoading(true);

    if (auth.currentUser) {
      await sendEmailVerification(auth.currentUser, {
        url: `${config.urls.admin}/verify`,
      }).catch((e: FirebaseError) => {
        console.log(e);
        toast.error(e.message);
      });
    }

    setLoading(false);
    setCounter(resendWaitTime);
    setResent(true);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((time) => (time <= 0 ? 0 : time - 1));
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="flex-row flex-grow justify-center my-auto">
      <div className="flex flex-row justify-center">
        <div className="border-2 shadow-lg p-8 bg-white rounded-xl">
          A verification email has been sent to your email address. After
          verifying your email, refresh the page to continue.
          <div className="mt-4 flex flex-row gap-4">
            <Button disabled={loading} onClick={() => refreshPage()}>
              <RefreshCcwIcon className="mr-2" /> Refresh
            </Button>
            <Button
              disabled={!!counter || loading}
              variant="secondary"
              onClick={handleResend}
            >
              {loading ? (
                <Loader2Icon className="text-secondary-foreground animate-spin mr-2" />
              ) : counter ? (
                <span className="text-xs inline-flex flex-row justify-center items-center text-center font-bold w-6 h-6 mr-2 bg-secondary-foreground text-secondary rounded-full">
                  {counter}
                </span>
              ) : (
                <SendHorizonalIcon className="text-secondary-foreground mr-2" />
              )}{" "}
              Re-send
            </Button>
            {resent && (
              <p className="mt-2 opacity-50">Verification email re-sent!</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
